import React from 'react'
import './hero.css'
import SearchIcon from '@mui/icons-material/Search';
import Heading from '../../../common/Heading';

const Hero = () => {
  return (
   <div className="hero">
    <div className="container ">
    <Heading title='Search Your Next Home' subtitle='Find new & Featured property location in your local city'/>

        <form action="" className="flex">
            <div className="box">
                <span>City/Street</span>
                <input type="text" placeholder='Location'  />
            </div>
            <div className="box">
                <span>Property Type</span>
                <input type="text" placeholder='Property Type'  />
            </div>
            <div className="box">
                <span>Price Range</span>
                <input type="text" placeholder='Price Range'  />
            </div>
            <div className="box">
                <h4>Advance Filter</h4>
            </div>
            <button className='btn'><SearchIcon/></button>
        </form>
    </div>
   </div>
  )
}

export default Hero
